import React from "react";
import { Link } from "react-router-dom";
import { Dots } from "react-dot-patterns";
import heroSectionImage from "../../../assets/service-pictures/software-development-down.jpg";

const HeroSection = () => {
  return (
    <div className="csd-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Overview</h1>
            <p>
              At Soori Corporation, we craft custom software solutions designed
              to solve your specific business challenges. Our team of experts
              works closely with you to design and develop applications that
              enhance efficiency, foster innovation, and support business
              growth. Whether you're looking for mobile, web, or desktop
              solutions, we offer end-to-end development services that cater to
              your unique needs.
            </p>
            <Link to="/industry">Book A Meeting</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
